import { render, staticRenderFns } from "./admissionFormCreate.vue?vue&type=template&id=0d2f9c4d"
import script from "./admissionFormCreate.vue?vue&type=script&lang=js"
export * from "./admissionFormCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports